/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2020-11-13 13:38:17
 * @Description: 封装table搜索条件
 */

import ApexSelect from './src/index'

ApexSelect.install = function(Vue) {
  Vue.component(ApexSelect.name, ApexSelect)
}

export default ApexSelect
